import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {Form, Input, InputNumber, Switch, Button, Card, message} from 'antd';
import {API_BASE_URL} from "../../config";


const AddCollection = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}/api/Collection`, {
                method: 'POST',
                headers: {
                    'Accept': 'text/plain',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: 0, // Backend avtomatik ID beradi
                    ...values,
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to add collection');
            }

            message.success('Collection added successfully');
            navigate('/collections'); // Muvaffaqiyatli qo'shgandan keyin sahifaga qaytish
        } catch (error) {
            message.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card title="Add New Collection" variant="borderless" style={{maxWidth: 600, margin: '0 auto'}}>
            <Form layout="vertical" onFinish={onFinish}>
                <Form.Item name="name" label="Name" rules={[{required: true, message: 'Please enter a name'}]}>
                    <Input placeholder="Enter collection name"/>
                </Form.Item>

                <Form.Item name="price" label="Price (UZS)" rules={[{required: true, message: 'Please enter a price'}]}>
                    <InputNumber min={0} style={{width: '100%'}} placeholder="Enter price"/>
                </Form.Item>

                <Form.Item name="limit" label="Limit (max)" rules={[{required: true, message: 'Please enter a limit'}]}>
                    <InputNumber min={1} max={100} style={{width: '100%'}} placeholder="Enter limit"/>
                </Form.Item>

                <Form.Item name="vipGroup" label="VIP Group"
                           rules={[{required: false, message: 'Please select a VIP group'}]}>
                    <Input placeholder="Enter cVIP Group"/>
                </Form.Item>

                <Form.Item name="active" label="Active" valuePropName="checked">
                    <Switch/>
                </Form.Item>
                <Form.Item name="olympics" label="Olimpiyada" valuePropName="checked">
                    <Switch/>
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading} block>
                        Add Collection
                    </Button>
                </Form.Item>

                <Form.Item>
                    <Button type="default" onClick={() => navigate('/collections')} block>
                        Cancel
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default AddCollection;
